import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import DashboardIcon from "../../icons/DashboardIcon";
import ClientIcon from "../../icons/ClientIcon";
import HivyIcon from "../../icons/HivyIcon";
import CloseIcon from "../../icons/CloseIcon";
import IdeasIcon from "../../icons/IdeasIcon";
import "../../../css/page/Menu.css";

const Menu = props => {
    const { page } = props;
    const [ visibilityBubble, setVisibilityBubble ] = useState(false);
    const [ textBubble, setTextBubble ] = useState(null);
    const navItems = [
        {
            "flag": "dashboard",
            "pages": ["dashboard"],
            "icon": <DashboardIcon />,
            "bubble": "Tableau de bord"
        },
        {
            "flag": "clients",
            "pages": ["client"],
            "icon": <ClientIcon />,
            "bubble": "Fichier client"
        },
        {
            "flag": "developmentrequests",
            "pages": ["developmentrequests"],
            "icon": <IdeasIcon />,
            "bubble": "Demande d'évolutions"
        }
    ];

    const hoverLink = item => {
        $(".menu .bubble").css("top", ($("#item-" + item.flag).offset().top - 3) + "px");
        setTextBubble(item.bubble);
        setVisibilityBubble(true);
    }
    const outLink = () => {
        setVisibilityBubble(false);
    }
    const handleClickCancelMenuMobile = () => {
        $(".menu").removeClass("visible");
    }

    useEffect(() => {
        if (visibilityBubble)
            $(".menu .bubble").addClass("visible")
        else
            $(".menu .bubble").removeClass("visible")
    }, [visibilityBubble]);

    return (
        <div className="menu hidden">
            { <p className="bubble">{ textBubble }</p> }
			<div className={"containerLogo"}>
            	<CloseIcon classname="cancelMenu" handleClick={ handleClickCancelMenuMobile } />
				<div className={"inLogo"}>
					<HivyIcon classname="logo" />
					<p className={"titleLogo"}>HIVY</p>
				</div>
			</div>
            <nav className="listItem" onMouseLeave={ () => { outLink() } }>
                {
                    navItems.map((item, index) => (
                        <Link key={ index } to={"/" + item.flag} onClick={handleClickCancelMenuMobile}>
                            <div id={"item-" + item.flag} className={"item" + (item.pages.includes(page) ? " selected" : "")} onMouseOver={() => { hoverLink(item) }}>
                                { item.icon }
								<p className={"text"}>{ item.bubble }</p>
                            </div>
                        </Link>
                    ))
				}
            </nav>
        </div>
	)
}

export default Menu;
